import { createI18n } from 'vue-i18n';
import { ru, en } from '@src/locales';
import { ConfigService } from '@src/services';

const defaultLanguage = ConfigService.getLanguage() || 'ru';
ConfigService.setLanguage(defaultLanguage);

export const i18n = createI18n({
  locale: defaultLanguage,
  messages: {
    ru,
    en,
  }
});